import { Form, Formik } from "formik";
import { motion } from "framer-motion";
import Input from "../../../../components/common/inputs/Input";
import TextArea from "../../../../components/common/inputs/TextArea";
import { getApi, putApi } from "../../../../services/api/globalApi";
import {
  errorMessage,
  successMessage,
  warningMessage,
} from "../../../../utils/toastify-message/ToastifyMessage";
import Select from "../../../common/inputs/Select";
import { useContext, useEffect, useRef, useState } from "react";
import { context } from "../../../../context/context";
import GetLoanModal from "../../../common/get-loans-modal/GetLoansModal";

function Information({ data, reGetData }) {
  const { user } = useContext(context);

  const handleReferrer = (values) => {
    if (data?.referrerUser || data?.referrerName?.length) {
      if (user?.role == "admin") {
        if (values?.referrerId.length && values?.referrerName?.length) {
          warningMessage(
            "شما فقط میتوانید یکی از موارد معرف یا نام معرف را وارد کنید."
          );
          return false;
        } else {
          return true;
        }
      } else {
        if (values?.referrerId.length && values?.referrerName?.length) {
          warningMessage(
            "شما فقط میتوانید یکی از موارد معرف یا نام معرف را وارد کنید."
          );
          return false;
        } else if (
          (values?.referrerId.length && !values?.referrerName?.length) ||
          (!values?.referrerId.length && values?.referrerName?.length) ||
          (!values?.referrerId.length && !values?.referrerName?.length)
        ) {
          if (values?.referrerId?.length || values?.referrerName?.length) {
            const referrerId = data?.referrerUser
              ? data?.referrerUser?._id
              : "";
            if (
              values?.referrerId == referrerId &&
              values?.referrerName == data?.referrerName
            ) {
              return true;
            } else {
              warningMessage("شما اجازه ویرایش معرف را ندارید.");
              return false;
            }
          } else {
            warningMessage("شما اجازه ویرایش معرف را ندارید.");
            return false;
          }
        }
      }
    } else {
      if (values?.referrerId.length && values?.referrerName?.length) {
        warningMessage(
          "شما فقط میتوانید یکی از موارد معرف یا نام معرف را وارد کنید."
        );
        return false;
      } else {
        return true;
      }
    }

    if (values?.referrerId.length && values?.referrerName?.length) {
      warningMessage(
        "شما فقط میتوانید یکی از موارد معرف یا نام معرف را وارد کنید."
      );
      return false;
    } else if (
      (values?.referrerId.length && !values?.referrerName?.length) ||
      (!values?.referrerId.length && values?.referrerName?.length)
    ) {
      if (user?.role == "admin") {
        return true;
      } else {
        if (values?.referrerId?.length) {
          if (values?.referrerId == data?.referrerUser?._id) {
            return true;
          } else {
            warningMessage("شما اجازه ویرایش معرف را ندارید.");
            return false;
          }
        } else if (data?.referrerName?.length) {
          if (values?.referrerName == data?.referrerName) {
            return true;
          } else {
            warningMessage("شما اجازه ویرایش معرف را ندارید.");
            return false;
          }
        }
      }
    } else if (!values?.referrerId?.length && !values?.referrerName?.length) {
      if (user?.role == "admin") {
        return true;
      } else {
        if (data?.referrerUser || data?.referrerName?.length) {
          warningMessage("شما اجازه ویرایش معرف را ندارید.");
          return false;
        } else {
          return true;
        }
      }
    }
  };

  const formHandler = async (values) => {
    const isAcceptReferrer = handleReferrer(values);
    if (isAcceptReferrer) {
      const path = `/admin/loans/${data?._id}`;
      const body = values;
      try {
        await putApi({ path, body });
        successMessage("اطلاعات کاربر با موفقیت ویرایش شد.");
        reGetData();
      } catch (error) {
        console.log(error);
        errorMessage(error?.response?.data?.errors[0]?.message);
      }
    }
  };

  const [referres, setReferrers] = useState([]);
  const getReferrer = async () => {
    const path = "users/referers";
    try {
      const response = await getApi({ path });
      setReferrers(response?.data?.docs);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getReferrer();
  }, []);

  const loanRef = useRef();

  return (
    <>
      <GetLoanModal ref={loanRef} installmentAmount={data?.installmentAmount} />
      <motion.div
        initial={{ opacity: 0, scale: 0.5 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{
          duration: 0.5,
          // ease: [0, 0.71, 0.2, 1.01]
        }}
        className="w-11/12 mx-auto  border border-gray-200 rounded-lg my-6 bg-white dark:bg-[#060d26] shadow-sm p-6"
      >
        <div className="flex flex-wrap w-full items-center justify-between">
          <h3 class="mb-4 text-lg font-medium leading-none text-gray-900 dark:text-white">
            مشخصات
          </h3>
          {data?.installmentAmount ? (
            <button
              onClick={() => loanRef.current.showModal()}
              className="text-white bg-[#3b5998] hover:bg-[#3b5998]/90 focus:ring-4 focus:outline-none focus:ring-[#3b5998]/50 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:focus:ring-[#3b5998]/55 me-2 mb-2"
            >
              وام هایی که کاربر میتوانید بگیرد
            </button>
          ) : null}
        </div>
        <Formik
          enableReinitialize
          initialValues={{
            nationalId: data?.nationalId || "",
            mobile: data?.mobile || "",
            bankAccountId: data?.bankAccountId || "",
            job: data?.job || "",
            jobDescription: data?.jobDescription || "",
            referrerId: data?.referrerUser?._id || "",
            referrerName: data?.referrerName || "",
          }}
          onSubmit={formHandler}
        >
          {() => (
            <Form>
              <div className="mt-6">
                <div className="grid gap-6 mb-6 md:grid-cols-2">
                  <Input
                    disabled
                    name="nationalId"
                    placeholder="شماره ملی"
                    label="شماره ملی"
                    type="text"
                  />

                  <Input
                    name="mobile"
                    placeholder="شماره"
                    label="شماره"
                    type="text"
                  />
                  <Input
                    name="bankAccountId"
                    placeholder="شماره حساب"
                    label="شماره حساب"
                    type="text"
                  />
                  <Input name="job" placeholder="شغل" label="شغل" type="text" />
                </div>
                <div className="grid gap-4">
                  <TextArea
                    name="jobDescription"
                    placeholder="توضیحات شغل"
                    label="توضیحات شغل"
                    type="text"
                  />
                </div>
                <div className="grid gap-6 mt-6 md:grid-cols-2">
                  <Select
                    name="referrerId"
                    placeholder="معرف"
                    label="معرف"
                    type="text"
                  >
                    <option value="">انتخاب معرف</option>
                    {referres?.length
                      ? referres?.map((item) => {
                          return (
                            <option value={item?._id}>{item?.name}</option>
                          );
                        })
                      : null}
                  </Select>
                  <Input
                    name="referrerName"
                    placeholder="نام معرف"
                    label="نام معرف"
                    type="text"
                  />
                </div>
                <button
                  type="submit"
                  class="mt-6 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                >
                  ثبت اطلاعات
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </motion.div>
    </>
  );
}

export default Information;
